export const CF_ID_TERMS_AND_CONDITIONS = '6dkVp9lcz7M2d0O5NgYt5v'
export const CF_ID_PRIVACY_POLICY = '51CCfMSxyIgnYPisnuTyEW'
